import React from 'react';

import { AuthProvider } from './auth';
import { ThemeAppProvider } from './theme';
import { PopupProvider } from './popup';
import { TimerProvider } from './TimerContext';

const AppProvider: React.FC = ({ children }) => {
  return (
    <ThemeAppProvider>
      <PopupProvider>
        <AuthProvider>
          <TimerProvider>{children}</TimerProvider>
        </AuthProvider>
      </PopupProvider>
    </ThemeAppProvider>
  );
};

export default AppProvider;
